/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card} from '../../../Shared/Card'
import { useQuery } from '@tanstack/react-query'
import { getPosImportStockState } from '../../../../../services/PointOfSale/PointOfSale.service'
import { TIME } from '../../../../../services/date.service'
import useUser from '../../../../Shared/UserProvider/useUser'
import { LoadingPlaceholderCardContent } from '../../../Shared/LoadingPlaceholderCardContent'
import { NoImportStockCardContent } from './NoImportStockCardContent'
import { THEME_COLORS } from '../../../../Shared/theme'
import { ImportStockCardContent } from './ImportStockCardContent'


const ImportStockCard = () => {
    const {user} = useUser()

    const {data, isLoading} = useQuery({
        queryKey: ['import-stock', user.provider.object.id],
        queryFn: () => getPosImportStockState(user.provider.object.id),
        staleTime: TIME.HOUR_IN_MS,
    })

    const getBorderColor = () => {
        if (isLoading) {
            return 'unset'
        }

        if (isLoading || !data) {
            return 'grey'
        }

        return data.state ? THEME_COLORS.GREEN : THEME_COLORS.RED
    }

    return (
      <Card
        css={css`
            border-top: 2px solid ${getBorderColor()};
            .card-content {
                width: 265px;
                height: 110px;
            }
        `}
      >
          {isLoading ? (
            <LoadingPlaceholderCardContent/>
          ) : !data ?
            <NoImportStockCardContent /> :
            <ImportStockCardContent data={data} />
          }
      </Card>
    )
}

export { ImportStockCard }
